import React, { useRef, useState } from 'react'
import Flex from '../Flex'
import Icon from '../Icon'
import Text from '../Text'
import { InputPasswordProps } from './Input.types'
import { InputWrapper, PlainInput } from './styled'

const InputPassword = React.forwardRef<HTMLInputElement, InputPasswordProps>(
  ({ label, hint, isError, size = 'regular', error, value, disabled, ...restProps }, ref) => {
    const inputRef =
      (ref as React.MutableRefObject<HTMLInputElement>) || useRef<HTMLInputElement>(null)

    const [isShow, setIsShow] = useState<boolean>(false)

    // hard to reproduce
    /* istanbul ignore next */
    const onClickInput = () => {
      if (inputRef.current) inputRef.current.focus()
    }

    const renderErrorText = () => {
      if (isError && error) {
        return (
          <Text variant='caption' color='red50' aria-label='input-error'>
            {error}
          </Text>
        )
      }
      if (hint) {
        return (
          <Text variant='caption' color='black50' aria-label='input-hint'>
            {hint}
          </Text>
        )
      }
    }

    return (
      <Flex flexDirection='column' rowGap='8px' width='100%'>
        {label && (
          <Text variant='caption' weight='bold' color='black50' aria-label='input-label'>
            {label}
          </Text>
        )}
        <InputWrapper
          aria-label='input-wrapper'
          size={size}
          isError={isError}
          onClick={onClickInput}
          disabled={disabled}
          style={{
            backgroundColor: restProps?.style?.backgroundColor ?? 'none',
          }}
        >
          <PlainInput
            type={isShow ? 'text' : 'password'}
            aria-label='plain-input'
            ref={inputRef}
            size={size}
            isError={isError}
            value={value}
            isPlain
            disabled={disabled}
            {...restProps}
          />
          <Icon
            name={isShow ? 'Show-solid' : 'Hide-solid'}
            cursor='pointer'
            size={size === 'regular' ? 20 : 16}
            aria-label='password-toggle'
            onClick={() => setIsShow((prev) => !prev)}
          />
        </InputWrapper>
        {renderErrorText()}
      </Flex>
    )
  },
)

export default InputPassword
